import { contactUsStructuredData } from '@helpers/constants';
import NextHeadTag from '@ui/molecules/NextHeadTag';
import { HeadTagData } from '@helpers/headTagData';
import ContactUS from '@components/ContactUs';
import StructuredData from '@components/StructuredData';
import {useEffect} from "react";
import {logEvent, moengageEventConstants} from "@services/moengage";

const ContactUs = () => {
    useEffect(() => {
        logEvent({eventName: moengageEventConstants.VIEWED_CONTACT_US_PAGE,});
    }, []);
    return (
        <>
            <NextHeadTag {...HeadTagData?.['/contact-us']} />
            <StructuredData data={contactUsStructuredData} />
            <ContactUS />
            
        </>
    );
};

export default ContactUs;
